import { Component, OnInit } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from '../sign-up-modal/sign-up-modal.component';
import { UserDataModalComponent } from '../user-data-modal/user-data-modal.component';
import { MyOrdersModalComponent } from '../my-orders-modal/my-orders-modal.component';

import { OrderNotExistModalComponent } from '../order-not-exist-modal/order-not-exist-modal.component';
import { lastValueFrom, retry } from 'rxjs';
import { ShowPersonalPromocodeComponent } from '../loyalty-components/show-personal-promocode/show-personal-promocode.component';
import { FacebookPixelEvent } from '../../../smoothr-web-app-core/enums/facebook-pixel-event';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';

enum Language {
	GreatBritain = 'en',
	German = 'de',
	Czech = 'cr',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['menu-modal.component.scss'],
})
export class MenuModalComponent extends RepositoryDirective implements OnInit {
	environment = environment;
	languageEnum = Language;
	loading = false;
	checkIfVenueExistImpressum;
	public userName: string = '';

	constructor(
		public repository: RepositoryService,
		private router: Router,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController,
		private analyticsService: AnalyticsService
	) {
		super(repository);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.checkIfVenueExistImpressum = '';
		if (this.customer.name) {
			this.userName = this.customer.name.split(/[ _]+/)[0];
		}
		if (this.repository._venue && this.repository._order) {
			if (this.repository._venue) {
				const ifUrlIncludes = this.router.url.includes('home') || this.router.url.includes('map');
				console.log(ifUrlIncludes, this.router.url, !this.repository._venue?.legal?.imprint && !ifUrlIncludes);
				if (!this.repository._venue?.legal?.imprint && !ifUrlIncludes) {
					this.checkToShowData(this.repository._venue._id);
				}
				return;
			} else {
				this.checkIfVenueExistImpressum = '';
			}
		}
	}

	async loadOrders() {
		console.log('load orders', !this.customer);
		if (!this.customer) {
			console.log('user not loaded');
			return;
		}

		const result = await Api.getCustomerOrders(this.customer.uid).catch(err => err);
		return result.data.withPayment || [];
	}

	private async checkToShowData(venueId: string) {
		try {
			const legal = (await Api.getLegal(venueId)).data;
			if (legal.type === 'pdf') {
				this.checkIfVenueExistImpressum = legal.imprint;
			}
		} catch (e) {
			console.error('Error while getting legal information');
			console.error(e);
		}
	}

	async signIn() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Login);
		const result = await SignInModalComponent.show(this.modalCtrl);
		if (result === 'sign-up') {
			this.signUp();
		}
	}

	async signUp() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Register);
		const result = await SignUpModalComponent.show(this.modalCtrl);
	}

	async myOrders() {
		this.loading = true;
		const orders = await this.loadOrders();
		await this.modalController.dismiss();

		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Orders);
		if (!orders.length) await OrderNotExistModalComponent.show(this.modalCtrl);
		else await MyOrdersModalComponent.show(this.modalController, orders);

		this.loading = false;
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			// this.repository.obserableOrder.next(null);
			// this.repository.previousPreorder.emit(null);

			await this.navigationService.home();

			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		console.log('Navigating to Privacy');
		await this.dismissModals();
		setTimeout(() => {
			this.navigationService.privacy();
		}, 300);
	}

	async tos() {
		console.log('Navigating to TOS');
		await this.dismissModals();
		setTimeout(() => {
			this.navigationService.tos();
		}, 300);
	}

	async impressum() {
		console.log('Navigating to Imprint');
		await this.dismissModals();
		setTimeout(() => {
			this.navigationService.imprint();
		}, 300);
	}

	private async dismissModals() {
		try {
			// Dismiss top modal which should be this menu
			await this.modalController.dismiss();
		} catch (e) {
			console.log('Modal dismiss error or already closed', e);
		}
	}

	async allergens() {
		await this.modalController.dismiss();
		// TODO open PDF
	}

	dismiss() {
		this.modalController.dismiss();
	}

	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}

	async willBeSoon() {
		await this.modalController.dismiss();

		this.snackbarCtrl.open('No design, will be soon...', null, {
			duration: 3000,
		});
	}

	async account() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		await UserDataModalComponent.show(this.modalController);
	}

	async cookie() {
		await this.modalController.dismiss();

		this.navigationService.cookie();
	}

	async myPromo() {
		try {
			await this.modalController.dismiss();
		} catch (e) {}
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.Loyalty);

		if (this.repository.customer.isAnonymous) {
			this.signIn();
		} else {
			this.navigationService.loyalty();
		}
	}

	async showMyPromo() {
		await ShowPersonalPromocodeComponent.show(
			this.modalCtrl,
			this.translate.instant('loyalty.personal_qr'),
			this.translate.instant('loyalty.personal_qr_subtitle'),
			environment.urlQrCode + 'user/' + this.customer?._id
		);
	}
}
